<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>平台提现审核</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="申请平台" prop="platformId">
            <el-select
              v-model="searchForm.platformId"
              placeholder="请选择申请平台"
              filterable
              clearable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现类型" prop="type">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择提现类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in types"
                :key="item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提现方式" prop="payType">
            <el-select
              style="width: 215px"
              v-model="searchForm.payType"
              placeholder="请选择提现方式"
              filterable
              clearable
            >
              <el-option
                v-for="item in payTypes"
                :key="item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in dictionaries.platform_withdrawl_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间" prop="brandId">
            <el-date-picker
              style="width: 215px"
              v-model="createdTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              :clearable="true"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户类型" prop="userType">
            <el-select
              v-model="searchForm.userType"
              placeholder="请选择用户类型"
              filterable
              clearable
            >
              <el-option
                v-for="item in userTypes"
                :key="item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户信息">
            <el-input
              placeholder="请输入用户信息"
              v-model="searchForm.userInfo"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核时间" prop="brandId">
            <el-date-picker
              style="width: 215px"
              v-model="approvedTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="true"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div style="display: flex">
        <h3>列表数据</h3>
        <div style="margin-left: 20px">
          <div
            style="
              width: 90px;
              height: 26px;
              background: #ffffff;
              border: 1px solid #4168e7;
              opacity: 1;
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 26px;
              color: #4168e7;
              text-align: center;
              cursor: pointer;
            "
            @click="settingPrice"
          >
            手续费设置
          </div>
          <!-- <el-button type="primary" plain size="small" @click="settingPrice"
            >手续费设置</el-button
          > -->
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="page.list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
    <el-dialog
      title="手续费设置"
      :visible.sync="isSetting"
      append-to-body
      width="640px"
    >
      <div style="margin-left: 10px">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="提现用户" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="1">平台服务商</el-radio>
              <el-radio label="2">平台用户提现</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="提现方式" prop="type">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="1" name="type" disabled>微信</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="提现手续费"
            prop="platformHandlingProportion"
            v-if="ruleForm.resource == 1"
          >
            <el-input
              v-model="ruleForm.platformHandlingProportion"
              placeholder="请输入"
              style="width: 120px"
            ></el-input>
            <el-input
              v-if="ruleForm.resource == 2"
              v-model="ruleForm.userHandlingProportion"
              placeholder="请输入"
              style="width: 120px"
            ></el-input>
            <span style="margin-left: 10px">%</span>
          </el-form-item>
          <el-form-item
            label="提现手续费"
            prop="userHandlingProportion"
            v-if="ruleForm.resource == 2"
          >
            <el-input
              v-model="ruleForm.userHandlingProportion"
              placeholder="请输入"
              style="width: 40%"
            ></el-input>
            <span style="margin-left: 10px">%</span>
          </el-form-item>
          <div
            style="
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 17px;
              color: #cccccc;
              margin-left: 100px;
            "
          >
            <span v-if="ruleForm.resource == 1"
              >收取提现总金额的{{
                ruleForm.platformHandlingProportion
              }}%手续费</span
            >
            <span v-if="ruleForm.resource == 2"
              >收取提现总金额的{{
                ruleForm.userHandlingProportion
              }}%手续费</span
            >
          </div>
        </el-form>
      </div>
      <div
        style="
          width: 640px;
          height: 0px;
          border: 1px solid #d9d9d9;
          opacity: 1;
          margin-left: -20px;
          margin-top: 30px;
        "
      ></div>
      <div style="margin-top: 14px; display: flex; justify-content: flex-end">
        <div class="c-btn" @click="isSetting = false">取消</div>
        <div class="q-btn" type="primary" @click="submit">确认</div>
      </div>
      <!-- <div style="margin-top: 60px; text-align: center">
        <el-button style="margin-right: 30px" @click="isSetting = false"
          >取消</el-button
        >
        <el-button type="primary" @click="submit">确认</el-button>
      </div> -->
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="isSuccess"
      append-to-body
      width="640PX"
    >
      <div
        style="margin-left: 10px; text-align: center"
        v-if="title == '审核通过'"
      >
        确认通过该用户的提现申请？
      </div>
      <div
        style="margin-left: 10px; text-align: center; font-size: 20px"
        v-else
      >
        是否打款？
      </div>
      <div style="display: flex; justify-content: center; line-height: 60px">
        <div>
          提现用户：<span style="color: red">{{ currentData.username }}</span>
        </div>
        <div style="margin-left: 10px">
          打款金额:<span style="color: red">
            {{ currentData.receivedMoney }}</span
          >
        </div>
      </div>
      <div style="margin-top: 20px; text-align: center">
        <el-button style="margin-right: 30px" @click="isSuccess = false"
          >取消</el-button
        >
        <el-button type="primary" @click="submitApply">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="审核驳回"
      :visible.sync="isReject"
      append-to-body
      width="640PX"
    >
      <el-form label-width="60px">
        <el-form-item label="备注">
          <el-input
            v-model="remark"
            style="width: 100%"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注内容"
            :rows="4"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 20px; text-align: center">
        <el-button style="margin-right: 30px" @click="isReject = false"
          >取消</el-button
        >
        <el-button type="primary" @click="submitReject">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../components/breadcrumb.vue'
import LbTable from '../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      loading: true,
      remark: '',
      approvedTime: [],
      createdTime: [],
      dictionaries: {},
      userTypes: [
        {
          id: 1,
          name: '平台用户'
        },
        {
          id: 2,
          name: '平台服务商'
        }
      ],
      types: [
        {
          id: 1,
          name: '佣金提现'
        },
        {
          id: 2,
          name: '保证金提现'
        },
        {
          id: 3,
          name: '结算金提现'
        }
      ],
      payTypes: [
        {
          id: 1,
          name: '微信'
        },
        {
          id: 2,
          name: '支付宝'
        },
        {
          id: 3,
          name: '银行卡'
        }
      ],
      title: '审核通过',
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台提现审核', path: '', type: '1' }
        ]
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        platformId: null,
        type: null,
        payType: null,
        status: null,
        createdTimeStart: '',
        createdTimeEnd: '',
        userType: null,
        userInfo: '',
        approvedTimeStart: '',
        approvedTimeEnd: ''
      },
      list: [
        {
          name: '天兰'
        },
        {

        },
        {

        }
      ],
      columns: [
        // { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '申请平台', prop: 'platformName', minWidth: '120' },
        {
          label: '提现用户', prop: 'username', minWidth: '200',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">提现用户</div>
            )
          },
          render: (h, scope) => {
            return (
              <div style="text-align:left">
                <div>姓名：{scope.row.username}</div>
                <div>ID：{scope.row.userId}</div>
                <div>电话：{scope.row.userPhone}</div>
              </div >
            )
          }
        },
        { label: '用户类型', prop: 'userTypeLabel', minWidth: '100' },
        {
          label: '申请时间', prop: 'createdTime', minWidth: '200',
        },
        { label: '提现类型', prop: 'typeLabel', minWidth: '100' },
        { label: '提现金额', prop: 'applyMoney', minWidth: '90' },
        { label: '手续费', prop: 'handlingFee', minWidth: '120' },
        { label: '实际到账', prop: 'receivedMoney', minWidth: '100' },
        { label: '提现方式', prop: 'payTypeLabel', minWidth: '100' },
        {
          label: '账号信息', prop: 'account', minWidth: '200',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">账号信息</div>
            )
          },
          render: (h, scope) => {
            return (
              <div style="text-align:left">
                <div class={(scope.row.payTypeLabel != '微信' && scope.row.payTypeLabel != '支付宝') ? '' : 'noshow'}>开户行：{scope.row.bankName}</div>
                <div>名称：{scope.row.accountName}</div>
                <div>账号：{scope.row.account}</div>
              </div >
            )
          }
        },
        {
          label: '状态', prop: 'statusLabel', minWidth: '100',
          renderHeader: (h, scope) => {
            return (
              <div style="text-align:left">状态</div>
            )
          },
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '待审核' || scope.row.statusLabel == '待打款' || scope.row.statusLabel == '打款中') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #F2A626;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else if (scope.row.statusLabel == '已驳回' || scope.row.statusLabel == '打款失败') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #F33F3F;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else if (scope.row.statusLabel == '打款成功') {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #12AB62;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background:  #C0C0CC;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div style="text-align:center"> {vv}</div>
            )

          }
        },
        { label: '审核时间', prop: 'approvedTime', minWidth: '200' },
        { label: '备注', prop: 'approveContent', width: '200px' },
        {
          label: '操作',
          minWidth: '200',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#409EFF;cursor:pointer' class={scope.row.status == 1 ? '' : 'noshow'} onClick={() => { this.applySuccess('apply', scope.row) }}>通过</span>
                <span style='color:#409EFF;cursor:pointer;margin-left:10px' class={(scope.row.status == 1 || scope.row.status == 6) ? '' : 'noshow'} onClick={() => { this.applyisReject(scope.row) }}>驳回</span>
                <span style='color:#409EFF;margin-left:10px;cursor:pointer' class={(scope.row.status == 3 || scope.row.status == 6) ? '' : 'noshow'} onClick={() => { this.applySuccess('success', scope.row) }}>打款</span>
              </div >
            )
          }
        }],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      isSetting: false,
      isSuccess: false,
      isReject: false,
      ruleForm: {
        type: ['1'],
        resource: '1',
        // price: '',
        platformHandlingProportion: '',
        userHandlingProportion: ''
      },
      rules: {
        type: [
          { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请至少选择一个', trigger: 'change' }
        ],
        userHandlingProportion: [
          {
            required: true, message: '请输入', trigger: 'blur'
          }
        ],
        platformHandlingProportion: [
          {
            required: true, message: '请输入', trigger: 'blur'
          }
        ]
      },
      platformList: [],
      form: {
        platformHandlingProportion: null,
        userHandlingProportion: null
      },
      recordId: null,
      currentData: {},
      currentDataJ: {},
    }
  },
  created () {
    this.goodsPlatforms()
    this.getDictionaries('platform_withdrawl_status')
    this.fetchData()
  },
  methods: {
    submitReject () {
      if (this.currentDataJ.status == 1) {
        let data = {
          id: this.currentDataJ.id,
          errorMsg: this.remark
        }
        this.$api.withdrawldoReject(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.isReject = false
            this.fetchData()
          }
        })
      } else {
        let data = {
          id: this.currentDataJ.id,
          errorMsg: this.remark
        }
        this.$api.withdrawldoFinanceReject(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.isReject = false
          }
        })
      }
    },
    //通过，打款
    submitApply () {
      if (this.title == '审核通过') {
        let data = {
          id: this.recordId
        }
        this.$api.withdrawldoPass(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '审核通过'
            });
            this.isSuccess = false
            this.fetchData()
          }
        })
      } else {
        let data = {
          id: this.recordId
        }
        this.$api.withdrawldoPay(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '打款成功'
            });
            this.isSuccess = false
            this.fetchData()
          }
        })
      }
    },
    //保存配置
    submit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let data = {
            platformHandlingProportion: Number(this.ruleForm.platformHandlingProportion),
            userHandlingProportion: Number(this.ruleForm.userHandlingProportion)
          }
          this.$api.saveWithdrawlConfig(data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '设置成功'
              });
              this.isSetting = false
            }
          })
        } else {

          return false;
        }
      });
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    fetchData (type) {
      if (this.searchForm.status == '') {
        this.searchForm.status = null
      }
      if (type == 'reset') {
        this.searchForm = {}
        this.createdTime = []
        this.approvedTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.createdTime) {
        this.searchForm.createdTimeStart = this.createdTime[0]
        this.searchForm.createdTimeEnd = this.createdTime[1]
      }
      if (this.approvedTime) {
        this.searchForm.approvedTimeStart = this.approvedTime[0]
        this.searchForm.approvedTimeEnd = this.approvedTime[1]
      }

      this.$api.getWithdrawlList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        }
      })
    },
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_withdrawl_status'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    add () {
      this.$router.push({
        name: 'platListDetail',
        query: {}
      })
    },
    settingPrice () {
      this.isSetting = true
      this.getConfig()
    },
    getConfig () {
      this.$api.getWithdrawlConfig({}).then(res => {
        if (res.code == 0) {
          this.ruleForm.platformHandlingProportion = res.data.platformHandlingProportion
          this.ruleForm.userHandlingProportion = res.data.userHandlingProportion
        }
      })
    },
    applySuccess (type, item) {
      if (type === 'apply') {
        this.title = '审核通过'
        this.isSuccess = true
      } else {
        this.title = '打款'
        this.isSuccess = true
      }
      this.currentData = item
      this.recordId = item.id
    },
    applyisReject (row) {
      this.remark = ''
      this.isReject = true
      this.currentDataJ = row
    },
    todetail () {
      this.$router.push({
        name: 'userDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.c-btn {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  margin-right: 24px;
  cursor: pointer;
}
.q-btn {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #ffffff;
  opacity: 1;
  text-align: center;
  cursor: pointer;
}
::v-deep .noshow {
  display: none !important;
}
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 6px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>

